import ProjectSite from "../ProjectSite";

describe("ProjectSite model", () => {
  test("hasMany relations", () => {
    expect(
      ProjectSite.hasMany.map(relation => relation.name)
    ).toMatchSnapshot();
  });
});
